import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-47f74eee"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "TeachingPlanEditorViewContainer"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "ml16"
}, "题型数量:", -1));
const _hoisted_3 = {
  class: "ml8",
  style: {
    "color": "#1388ff"
  }
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "ml16"
}, "套题数量:", -1));
const _hoisted_5 = {
  class: "ml8",
  style: {
    "color": "#1388ff"
  }
};
const _hoisted_6 = {
  style: {
    "color": "#1388ff"
  }
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "divider mt6"
}, null, -1));
const _hoisted_8 = {
  key: 0,
  class: "divider mb6",
  style: {
    "background": "#EEEEEE"
  }
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "color": "lightcoral"
  },
  class: "ft12 ptr"
}, "删除", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_row = _resolveComponent("el-row");
  const _component_el_col = _resolveComponent("el-col");
  const _component_el_popconfirm = _resolveComponent("el-popconfirm");
  const _component_QuestionTplSelector = _resolveComponent("QuestionTplSelector");
  const _component_el_drawer = _resolveComponent("el-drawer");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_row, {
    class: "flex items-center pd12 wbg ft14"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_button, {
      icon: "Plus",
      type: "primary",
      onClick: _cache[0] || (_cache[0] = $event => $data.drawer = true)
    }, {
      default: _withCtx(() => [_createTextVNode("添加套题")]),
      _: 1
    }), _hoisted_2, _createElementVNode("span", _hoisted_3, _toDisplayString(Object.keys($data.map).length), 1), _hoisted_4, _createElementVNode("span", _hoisted_5, _toDisplayString($data.plan.tplIds.length), 1)]),
    _: 1
  }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys($data.map), m => {
    return _openBlock(), _createBlock(_component_el_row, {
      class: "pd12 wbg mt12 flex flex-col",
      key: m
    }, {
      default: _withCtx(() => [_createElementVNode("span", _hoisted_6, _toDisplayString($data.mapping[m]), 1), _hoisted_7, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.map[m], (t, ti) => {
        return _openBlock(), _createElementBlock(_Fragment, {
          key: t.id
        }, [ti > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_8)) : _createCommentVNode("", true), _createVNode(_component_el_row, {
          class: "flex items-center justify-center ft14"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 8,
            class: "flex items-center"
          }, {
            default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(t.tplName), 1)]),
            _: 2
          }, 1024), _createVNode(_component_el_col, {
            span: 8,
            class: "flex items-center"
          }, {
            default: _withCtx(() => [_createElementVNode("span", null, "题目数量:" + _toDisplayString(t.totalQuestionSize), 1)]),
            _: 2
          }, 1024), _createVNode(_component_el_col, {
            span: 8,
            class: "flex items-center"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_popconfirm, {
              title: "确定删除吗",
              onConfirm: $event => $options.deleteTplFromPlan(t.id)
            }, {
              reference: _withCtx(() => [_hoisted_9]),
              _: 2
            }, 1032, ["onConfirm"])]),
            _: 2
          }, 1024)]),
          _: 2
        }, 1024)], 64);
      }), 128))]),
      _: 2
    }, 1024);
  }), 128))]), _createVNode(_component_el_drawer, {
    modelValue: $data.drawer,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.drawer = $event),
    title: "添加套题",
    size: "1200px",
    "with-header": false
  }, {
    default: _withCtx(() => [_createVNode(_component_QuestionTplSelector, {
      onSelect: $options.onSelected
    }, null, 8, ["onSelect"])]),
    _: 1
  }, 8, ["modelValue"])], 64);
}